var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmbulatorioCopa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9182 6.32917H19.5545V4.57917H17.9182V6.32917ZM17.9182 11.3167H19.5545V9.56667H17.9182V11.3167ZM17.9182 16.275H19.5545V14.525H17.9182V16.275ZM16.3909 21V19.25H22.3636V1.75H11.5909V5.01667L9.95455 3.79167V0H24V21H16.3909ZM0 21V9.625L7.39091 3.96667L14.7545 9.625V21H8.83636V15.1375H5.94545V21H0ZM1.63636 19.25H4.30909V13.3875H10.4727V19.25H13.1182V10.5292L7.39091 6.125L1.63636 10.5415V19.25Z",
    fill: "#DF8D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulatorioCopa);
export default __webpack_public_path__ + "static/media/ambulatorioCopa.807249d47fd4b50e28c0ba76bc52cc2d.svg";
export { ForwardRef as ReactComponent };